// english

export default {
  menu_interface_title: '菜单和接口',

  // form
  menu_interface_form_menu: '父菜单',
  menu_interface_form_menu_placeholder: '请选择父菜单',
  menu_interface_form_auth_name: '权限名称',
  menu_interface_form_auth_name_placeholder: '请输入权限名称',
  menu_interface_form_url: 'URL',
  menu_interface_form_auth_common: '通用权限',
  menu_interface_form_auth_common_help:
    '选中时，所有用户都具有此菜单的权限，角色的权限分配中不再显示。',
  menu_interface_default_auth: '[通用]',

  // menu
  menu_btn_add: '添加菜单',
  menu_confirm_delete_title: '确定删除该菜单?',
  menu_confirm_delete_content_name: '菜单名称: {name}',
  menu_confirm_delete_content_url: '菜单URL: {name}',
  menu_delete_error: '菜单下有接口时，不允许删除',

  menu_edit_title: '编辑菜单',
  menu_add_title: '添加菜单',

  menu_form_name: '菜单名称',
  menu_form_name_placeholder: '请入菜单名称',
  menu_form_sort: '排序',
  menu_form_sort_help: '从小到大排序',
  menu_form_sort_placeholder: '请入排序数字',
  menu_form_url_placeholder: '请入菜单URL',
  menu_table_parent_id: '父菜单 ID',
  menu_table_parent_name: '父菜单名称',

  // interface
  interface_title: '接口列表',
  interface_btn_add: '添加接口',
  interface_edit_title: '编辑接口',
  interface_add_title: '添加接口',
  interface_confirm_delete_title: '确定删除该接口?',
  interface_confirm_delete_content_name: '接口名称: {name}',
  interface_confirm_delete_content_url: '接口URL: {name}',
  interface_confirm_auth_access_tip: '所有用户将拥有该接口的权限?',
  interface_form_name: '接口名称',
  interface_form_name_placeholder: '请入接口名称',

  interface_form_url_placeholder: '请入接口URL',
  interface_form_method: 'Method',
  interface_form_method_placeholder: '请选择Method',
};
